import { date_dmy_func } from "../../components/Common/CommonFunction";
import { numberWithCommas } from "../Report_common_function";

export const columns = [
    "Scheme Name",
    "Customer Company",
    "Validity From",
    "Validity To",
    "Voucher Amount",
    "Bill Amount",
    "Total Coupon",
    "Used Coupon",
];

// ⭐ Computes the overall From/To range across every scheme in the response
export const getDateRange = (schemes = []) => {
    if (!Array.isArray(schemes) || schemes.length === 0) {
        return { fromDate: null, toDate: null };
    }

    let minFrom = null;
    let maxTo = null;

    schemes.forEach((s) => {
        if (s.FromPeriod) {
            const f = new Date(s.FromPeriod);
            if (!minFrom || f < minFrom) minFrom = f;
        }
        if (s.ToPeriod) {
            const t = new Date(s.ToPeriod);
            if (!maxTo || t > maxTo) maxTo = t;
        }
    });

    return {
        fromDate: minFrom ? minFrom.toISOString().substring(0, 10) : null,
        toDate: maxTo ? maxTo.toISOString().substring(0, 10) : null,
    };
};

export const Rows = (schemes = []) => {
    const rows = [];

    let grandVoucherAmount = 0;
    let grandBillAmount = 0;
    let grandTotalCoupon = 0;
    let grandUsedCoupon = 0;

    (Array.isArray(schemes) ? schemes : []).forEach((scheme) => {
        const companies = scheme.SchemeCustomerCompanyList || [];
        const schemeName = scheme.SchemeNameText || scheme.SchemeName || "";
        const schemeValue = Number(scheme.SchemeValue ?? 0); // ⭐ rate, applied differently below

        let schemeBillAmount = 0;
        let schemeTotalCoupon = 0;
        let schemeUsedCoupon = 0;
        let schemeVoucherAmount = 0; // ⭐ sums whatever voucher amount is shown per row

        if (companies.length === 0) {
            // ⭐ No company list -> use scheme-level TotalVoucherCodeCount
            const total = Number(scheme.TotalVoucherCodeCount ?? 0);
            const used = Number(scheme.InactiveVoucherCodeCount ?? 0);
            const voucherAmount = schemeValue * total;

            schemeTotalCoupon += total;
            schemeUsedCoupon += used;
            schemeVoucherAmount += voucherAmount;

            rows.push([
                schemeName,
                "",
                date_dmy_func(scheme.FromPeriod),
                date_dmy_func(scheme.ToPeriod),
                `${numberWithCommas(voucherAmount.toFixed(2))}`,
                "0.00",
                `${total}`,
                `${used}`,
                "row",
            ]);
        } else {
            // ⭐ Has company list -> use each company's own VoucherCount
            companies.forEach((c, idx) => {
                const billAmount = Number(c.Amount ?? 0);
                const total = Number(c.VoucherCount ?? 0);
                const used = Number(c.InactiveVoucher ?? 0);
                const voucherAmount = schemeValue * total; // ⭐ per-company

                schemeBillAmount += billAmount;
                schemeTotalCoupon += total;
                schemeUsedCoupon += used;
                schemeVoucherAmount += voucherAmount;

                rows.push([
                    idx === 0 ? schemeName : "",
                    c.PartyName || "",
                    date_dmy_func(c.ValidityFrom),
                    date_dmy_func(c.ValidityTo),
                    `${numberWithCommas(voucherAmount.toFixed(2))}`,
                    `${numberWithCommas(billAmount.toFixed(2))}`,
                    `${total}`,
                    `${used}`,
                    "row",
                ]);
            });
        }

        rows.push([
            `Scheme Total:`,
            "", "", "",
            `${numberWithCommas(schemeVoucherAmount.toFixed(2))}`, // ⭐ sum of the rows above
            `${numberWithCommas(schemeBillAmount.toFixed(2))}`,
            `${schemeTotalCoupon}`,
            `${schemeUsedCoupon}`,
            "subtotal",
        ]);

        grandVoucherAmount += schemeVoucherAmount;
        grandBillAmount += schemeBillAmount;
        grandTotalCoupon += schemeTotalCoupon;
        grandUsedCoupon += schemeUsedCoupon;
    });

    if (schemes.length > 0) {
        rows.push([
            "Grand Total",
            "", "", "",
            `${numberWithCommas(grandVoucherAmount.toFixed(2))}`,
            `${numberWithCommas(grandBillAmount.toFixed(2))}`,
            `${grandTotalCoupon}`,
            `${grandUsedCoupon}`,
            "grandtotal",
        ]);
    }

    return rows;
};